<template>
  <div class="footer">
    <div class="footerNav">
      <p class="footerNavTitle clear">商务合作</p>
      <p class="footerNavDesc clear">BUSINESS COOPERATION</p>
      <div class="footerNavBot">
        <ul class="footerNavBotCom">
          <li class="comList" v-for="(item, index) in comArr" :key="index">
            <img class="comListImg" :src="item.icon" alt="logo" />
            <p class="comListTitle clear">{{ item.title }}</p>
            <p class="comListDesc clear">{{ item.desc }}</p>
          </li>
        </ul>
        <div class="footerNavBotQr">
          <div class="qrList" v-for="(item, index) in qrArr" :key="index">
            <img class="qrListImg" :src="item.qr" alt="二维码" />
            <p class="qrListTitle clear">{{ item.title }}</p>
          </div>
          <span v-if="index !== 1" class="footerNavBotQrLine" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const comArr = [
  {
    icon: 'https://p1.ssl.qhimg.com/t01ac02256b3ce23906.png',
    title: '联系人',
    desc: '马欣'
  },
  {
    icon: 'https://p1.ssl.qhimg.com/t0114e36e357d20b9aa.png',
    title: 'Email',
    desc: 'ISC@360.cn'
  },
  {
    icon: 'https://p4.ssl.qhimg.com/t01933293f146ba2880.png',
    title: '电话',
    desc: '15718876610'
  }
]
const qrArr = [
  {
    qr: 'https://p2.ssl.qhimg.com/t011653222351b02f73.png',
    title: 'ISC APP下载'
  },
  {
    qr: 'https://p2.ssl.qhimg.com/t01939c2de2744eb423.png',
    title: '微信公众号'
  }
]
</script>

<style lang="scss" scoped>
.clear {
  margin: 0;
}
.footer {
  position: relative;
  top: -1px;
  height: 474px;
  background: #000;
  &Nav {
    position: absolute;
    top: -41px;
    left: 50%;
    transform: translateX(-50%);
    width: 382px;
    height: 451px;
    border-radius: 8px;
    background: #fcfcfc;
    padding: 32px;
    color: #3d3d3d;
    &Title {
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
    }
    &Desc {
      font-size: 14px;
      line-height: 22px;
      margin: 3px 0 24px;
    }
    &Bot {
      &Com {
        margin-top: 22px;
      }
      &Qr {
        position: relative;
        display: flex;
        justify-content: space-between;
        .qrList {
          &Title {
            text-align: center;
          }
          &Img {
            width: 120px;
            height: 120px;
            padding: 5px;
            // border: 1px dashed #d8d8d8;
          }
        }
        &Line {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateY(-50%);
          display: inline-block;
          background-color: #d8d8d8;
          width: 1px;
          height: 90px;
        }
      }
    }
    .comList {
      list-style: none;
      display: flex;
      width: 320px;
      margin-bottom: 22px;
      &Img {
        width: 20px;
        height: 20px;
      }
      &Title {
        min-width: 54px;
        margin: 0 10px 0 15px;
        font-size: 18px;
        line-height: 24px;
        color: rgba(61, 61, 61, 0.6);
      }
      &Desc {
        font-size: 18px;
        line-height: 24px;
        color: #3d3d3d;
      }
    }
  }
}
</style>
